import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "webassistant-preview-container" }
const _hoisted_2 = { class: "webassistant-preview-root" }
const _hoisted_3 = { class: "wa-container" }
const _hoisted_4 = { class: "wa-chatbox" }
const _hoisted_5 = { class: "wa-shadow" }

import Vue, { computed, PropType } from 'vue';
import HomeScreenPreview from './homescreenPreview/HomeScreenPreview.vue';
import ConversationPreview from './conversationPreview/ConversationPreview.vue';
import WebAssistantLauncher from './WebAssistantLauncher.vue';
import ColourService from '@/shared/services/color';
import { HomescreenAppInitViewModel, TypicalResponseTimeOptions } from '../models';
import { ConversationMessage } from '@/features/webassistant/models/conversation-message';


export default /*@__PURE__*/_defineComponent({
  __name: 'WebAssistantPreview',
  props: {
  brandColour: {
    type: String,
  },
  outboundMessageColour: {
    type: String,
  },
  actionColour: {
    type: String,
  },
  headerText: {
    type: String,
  },
  homescreenImageUrl: {
    type: String,
  },
  greetingText: {
    type: String,
  },
  introductionText: {
    type: String,
  },
  typicalResponseTime: {
    type: Number,
    required: true,
  },
  displayLauncher: {
    type: Boolean,
    default: true,
  },
  messages: {
    type: Array as PropType<ConversationMessage[]>,
  },
  isOpen: {
    type: Boolean,
    required: true,
  },
  activeView: {
    type: String as PropType<'homescreen' | 'conversation'>,
    default: 'homescreen',
  },
  disableInteraction: {
    type: Boolean,
  },
  readonlyApps: {
    type: Boolean,
    default: true,
  },
  homescreenApps: {
    type: Array as PropType<HomescreenAppInitViewModel[]>,
  },
},
  emits: ["load", "sendQuickReply", "messageSend", "conversationRead", "typingStart", "typingStop", "launcherButtonClick"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const typicalResponseTimeString = computed(() => {
  if (props.typicalResponseTime === 0) {
    return 'Web Assistant';
  }
  return `We typically reply ${TypicalResponseTimeOptions[props.typicalResponseTime].label.toLowerCase()}`;
});

function getContrastingBrandColour() {
  return ColourService.getContrastingColour(props.brandColour);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_Transition, { name: "fade-shadow" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [
                [_vShow, __props.isOpen]
              ])
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["chat-container notFullscreen", { 'chat-container__static': __props.disableInteraction }])
              }, [
                _withDirectives(_createVNode(HomeScreenPreview, {
                  brandColour: __props.brandColour,
                  actionColour: __props.actionColour,
                  homescreenImageUrl: __props.homescreenImageUrl,
                  greetingText: __props.greetingText,
                  introductionText: __props.introductionText,
                  "typical-response-time": typicalResponseTimeString.value,
                  homescreenApps: __props.homescreenApps
                }, null, 8, ["brandColour", "actionColour", "homescreenImageUrl", "greetingText", "introductionText", "typical-response-time", "homescreenApps"]), [
                  [_vShow, __props.activeView === 'homescreen']
                ]),
                _withDirectives(_createVNode(ConversationPreview, {
                  "brand-colour": __props.brandColour,
                  outboundMessageColour: __props.outboundMessageColour,
                  "action-colour": __props.actionColour,
                  "header-text": __props.headerText,
                  messages: __props.messages,
                  "typical-response-time": typicalResponseTimeString.value,
                  "readonly-apps": __props.readonlyApps,
                  onSendQuickReply: _cache[0] || (_cache[0] = (quickReply) => emit('sendQuickReply', quickReply)),
                  onMessageSend: _cache[1] || (_cache[1] = (message) => emit('messageSend', message)),
                  onConversationRead: _cache[2] || (_cache[2] = ($event: any) => (emit('conversationRead'))),
                  onTypingStart: _cache[3] || (_cache[3] = ($event: any) => (emit('typingStart'))),
                  onTypingStop: _cache[4] || (_cache[4] = ($event: any) => (emit('typingStop')))
                }, null, 8, ["brand-colour", "outboundMessageColour", "action-colour", "header-text", "messages", "typical-response-time", "readonly-apps"]), [
                  [_vShow, __props.activeView === 'conversation']
                ])
              ], 2), [
                [_vShow, __props.isOpen]
              ])
            ]),
            _: 1
          })
        ]),
        (__props.displayLauncher)
          ? (_openBlock(), _createBlock(WebAssistantLauncher, {
              key: 0,
              backgroundColour: __props.brandColour,
              iconColour: getContrastingBrandColour(),
              isOpen: __props.isOpen,
              onButtonClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('launcherButtonClick')))
            }, null, 8, ["backgroundColour", "iconColour", "isOpen"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})